import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

// Names this page on its AccountApi calls, so the server's registration events can tell the
// legacy page from rack-web and from other callers of the same endpoints (#500).
const options = { headers: new HttpHeaders({ 'X-Rack-Client': 'rack-public-ng' }) };

@Injectable({
  providedIn: 'root'
})
export class RegistrationService {

  constructor(private http: HttpClient) { }

  recordAbandonedRegistration(data) {
    return this.http.post('/api/AccountApi/RecordAbandonedRegistration', data, options);
  }

  submit(data) {
    return this.http.post('/api/AccountApi/SaveRegistration', data, options);
  }

  registerUser(data) {
    return this.http.post('/api/AccountApi/RegisterUserAccount', data, options);
  }

  completeRegistration(data) {
    return this.http.post('/api/AccountApi/CompleteRegistration', data, options);
  }

  getRegistrationStatus() {
    return this.http.get('/api/AccountApi/RegistrationStatus', options);
  }

  doesUserExist(username) {
    return this.http.get('/api/AccountApi/DoesUserExist?username='+username, options);
  }

  existingUserLogin(data) {
    return this.http.post('/api/AccountApi/ExistingUserLogin', data, options);
  }

  selectSubscriptions(data) {
    return this.http.post('/api/AccountApi/SelectSubscriptionsForNewAccount', data, options);
  }

  getOfferCodeDetails(offerCode) {
    return this.http.get('/api/AccountApi/GetOfferCodeDetails?code=' + offerCode, options);
  }

  registerParent(data){
    return this.http.post('/api/AccountApi/RegisterParentAccount', data, options);
  }
}
